import { Injectable } from '@angular/core';
import { PageDto } from 'app/@types/dto/page-dto.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ActivePageService {
    private activePage$: BehaviorSubject<PageDto | null> = new BehaviorSubject<PageDto | null>(null);

    public getActivePage() {
        return this.activePage$.asObservable().pipe(filter((activePage) => !!activePage));
    }

    public setActivePage(newPage: PageDto) {
        this.activePage$.next(newPage);
        // For some reason the setContextField override with the one on the questionnaire state.
        // Temporarily using a timeout to avoid the issue.
        // Setting it to 1 sec shouldn't be a problem since the context will not be used before a message is sent.
        setTimeout(() => {
            Chathive.widget.setContextField({ key: 'currentPage', value: newPage.pageCode });
        }, 1000);
    }
}
